/* eslint-disable camelcase */
/* eslint-disable react/function-component-definition */
import PropTypes from "prop-types";

import { useEffect, useState } from "react";

// sito components
import SitoContainer from "sito-container";
import SitoImage from "sito-image";

// own components
import DataTable from "components/MUI/DataTable/DataTable";
import Empty from "components/MUI/Empty/Empty";
import Error from "components/MUI/Error/Error";
import Loader from "components/Loader/Loader";

// services
import { userList, getAgents, getMe } from "services/get";

// functions
import { isAdmin } from "utils/functions";

// contexts
import { useLanguage } from "context/LanguageProvider";
import { useNotification } from "context/NotificationProvider";

const List = (props) => {
  const { navigateToInsert } = props;
  const { languageState } = useLanguage();
  const { setNotificationState } = useNotification();

  const [localList, setLocalList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = async () => {
    setLoading(true);
    let response;
    if (isAdmin()) response = await userList();
    else response = await getAgents();
    if (response.status === 200) {
      const { data } = await response.data;
      if (data.length) {
        let parsedUsers = data;
        if (!isAdmin()) {
          const { inmobiliaria_id } = await getMe();
          parsedUsers = [];
          data.forEach((item) => {
            if (inmobiliaria_id === item.inmobiliaria_id) parsedUsers.push(item);
          });
        }
        const parsedColumns = [];
        Object.keys(data[0]).forEach((item) => {
          if (item === "id") parsedColumns.push({ field: item, width: 90 });
          else
            parsedColumns.push({
              field: item,
              headerName: languageState.texts.Dashboard.TableAttributes[item],
              width: 200,
              editable: false,
            });
        });
        const parsedRows = [];

        parsedUsers.forEach((item) => {
          const parsedItem = { ...item };
          if (parsedItem.imagen) {
            parsedItem.imagen = (
              <SitoImage
                sx={{ borderRadius: "100%", width: "60px", height: "60px" }}
                src={parsedItem.imagen}
                alt={parsedItem.nombre}
              />
            );
          }
          if (parsedItem.status || parsedItem.status === 0)
            parsedItem.status = languageState.texts.Dashboard.User.Status[parsedItem.status];
          parsedRows.push(parsedItem);
        });
        setColumns(parsedColumns);
        setLocalList(parsedRows);
      }
    } else {
      setLocalList(-1);
      setNotificationState({
        type: "set",
        message: languageState.texts.Errors.NotConnected,
        ntype: "error",
      });
    }
    setLoading(false);
  };

  const retry = () => {
    fetch();
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <SitoContainer
      alignItems="center"
      justifyContent="center"
      sx={{ position: "relative", minHeight: "300px" }}
    >
      <Loader visible={loading} minimal />
      {!loading && localList.length > 0 && <DataTable columns={columns} rows={localList} />}
      {!loading && !localList.length && localList !== -1 && <Empty onAction={navigateToInsert} />}
      {!loading && localList === -1 && <Error onAction={retry} />}
    </SitoContainer>
  );
};

List.propTypes = {
  navigateToInsert: PropTypes.func.isRequired,
};

export default List;
